module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp13_7042.1a10aa77.png";